// extracted by mini-css-extract-plugin
export default {"tabs":"WhyIsAirQualityImportant_tabs__93Cxv","tabContainer":"WhyIsAirQualityImportant_tabContainer__eSron"};